import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { Button } from "../../components/ui/button";
import { ArrowLeft } from "lucide-react";
import api from "../../lib/api";

export default function ExplorerPass() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [student, setStudent] = useState(null);

  useEffect(() => {
    api.get("/students").then((r) => setStudent(r.data.find((s) => s.id === studentId))).catch(() => {});
  }, [studentId]);

  if (!student) return <AppShell><div className="py-20 text-center text-slateBrand">Loading…</div></AppShell>;

  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(student.student_id)}&color=102A43&bgcolor=ffffff`;

  return (
    <AppShell>
      <Button variant="ghost" onClick={() => navigate("/students")} className="mb-6 font-display font-semibold text-navy"><ArrowLeft className="mr-2 h-4 w-4" />Back to Students</Button>
      <div className="mx-auto max-w-sm">
        <div className="overflow-hidden rounded-3xl bg-navy text-white shadow-xl" data-testid="explorer-pass-card">
          <div className="flex items-center justify-between px-7 pt-7">
            <div>
              <div className="eyebrow text-gold">H.E.A.</div>
              <div className="font-display text-lg font-bold">Explorer Pass</div>
            </div>
            <div className="text-right text-xs text-white/50">Member</div>
          </div>
          <div className="flex flex-col items-center px-7 py-6">
            <div className="rounded-2xl bg-white p-4" data-testid="explorer-pass-qr-code">
              <img src={qrUrl} alt="QR code" className="h-40 w-40" />
            </div>
            <div className="mt-5 text-center">
              <div className="font-display text-2xl font-bold">{student.first_name} {student.last_name}</div>
              <div className="mt-1 text-sm text-white/60">Grade {student.grade} {student.age ? `• Age ${student.age}` : ""}</div>
            </div>
          </div>
          <div className="flex items-center justify-between border-t border-white/10 px-7 py-4 text-xs">
            <span className="text-white/50">Student ID</span>
            <span className="font-mono font-semibold text-exploration">{student.student_id}</span>
          </div>
        </div>
        <p className="mt-4 text-center text-xs text-slateBrand">Present this pass at check-in. Staff scan the QR to verify registration and forms.</p>
      </div>
    </AppShell>
  );
}
